import React from 'react';
import PropTypes from 'prop-types';
import { REPORT_IDS } from '../../constants/constants';
import TaskListReportFilters from './Filters/TaskListReportFilters';
import PastDueTaskListFilters from './Filters/PastDueTaskListFilters';
import CoachSummaryFilters from './Filters/CoachSummaryFilters';
import ProjectCrosstabFilters from './Filters/ProjectCrosstabFilters';
import BaselineTaskListFilters from './Filters/BaselineTaskListFilters';
import LocationTaskSummaryFilters from './Filters/LocationTaskSummaryFilters';
import LocationListFilters from './Filters/LocationListFilters';
import ProjectLocListFilters from './Filters/ProjectLocListFilters'
import LocationSummaryPerProject from './Filters/LocationSummaryPerProject';
import ProjectListFilters from './Filters/ProjectListFilters';
import ProjectsPerLocationFilters from './Filters/ProjectsPerLocationFilters';
import ProjectTasksListFilters from './Filters/ProjectTasksListFilters';
import ProjectDeploymentListFilters from './Filters/ProjectDeploymentListFilters';
import UserListFilters from './Filters/UserListFilters';
import MilestoneCrosstabFilters from './Filters/MilestonesCrosstabFilters';
import SupportTicketsFilters from './Filters/SupportTicketsFilters';
import GMSummaryFilters from './Filters/GMSummaryFilters';
import PastDuePreRequisiteTaskFilters from './Filters/PastDuePreRequisiteTaskFilters';

const ReportFiltersManager = (props) => {

    const report = props.report;
    const filters = props.filters;
    const urlParams = props.urlParams;
    const savedFilterValues = props.savedFilterValues;
    const isFormValid = props.isFormValid;
    const registerReportFilterFunctions = props.registerReportFilterFunctions;
    const onLocationChange = props.onLocationChange;
    const onProjectChange = props.onProjectChange;
    const onCoachChange = props.onCoachChange;
    const isSchedulingMode = props.isSchedulingMode;
    const selectedProject = props.selectedProject;

    switch (report.id) {
        case REPORT_IDS.TaskList:
            return (
                <TaskListReportFilters
                    report={report}
                    filters={filters}
                    urlParams={urlParams}
                    savedFilterValues={savedFilterValues}
                    isFormValid={isFormValid}
                    registerReportFilterFunctions={registerReportFilterFunctions}
                    onLocationChange={onLocationChange}
                    isSchedulingMode={isSchedulingMode}
                />
            );
        case REPORT_IDS.PastDueTaskList:
            return (
                <PastDueTaskListFilters
                    report={report}
                    filters={filters}
                    urlParams={urlParams}
                    savedFilterValues={savedFilterValues}
                    isFormValid={isFormValid}
                    registerReportFilterFunctions={registerReportFilterFunctions}
                    onLocationChange={onLocationChange}
                />
            );
        case REPORT_IDS.CoachSummary:
            return (
                <CoachSummaryFilters
                    report={report}
                    filters={filters}
                    urlParams={urlParams}
                    savedFilterValues={savedFilterValues}
                    isFormValid={isFormValid}
                    registerReportFilterFunctions={registerReportFilterFunctions}
                    isSchedulingMode={isSchedulingMode}
                    onCoachChange={onCoachChange}
                />
            );
        case REPORT_IDS.ProjectCrosstab:
            return (
                <ProjectCrosstabFilters
                    report={report}
                    filters={filters}
                    urlParams={urlParams}
                    savedFilterValues={savedFilterValues}
                    isFormValid={isFormValid}
                    registerReportFilterFunctions={registerReportFilterFunctions}
                    onProjectChange={onProjectChange}
                    isSchedulingMode={isSchedulingMode}
                />
            );
        case REPORT_IDS.LocationsList:
            return (
                <LocationListFilters
                    report={report}
                    filters={filters}
                    urlParams={urlParams}
                    savedFilterValues={savedFilterValues}
                    isFormValid={isFormValid}
                    registerReportFilterFunctions={registerReportFilterFunctions}
                    onProjectChange={onProjectChange}
                    isSchedulingMode={isSchedulingMode}
                />
            );
        case REPORT_IDS.LocationTaskSummary:
            return (
                <LocationTaskSummaryFilters
                    report={report}
                    filters={filters}
                    urlParams={urlParams}
                    savedFilterValues={savedFilterValues}
                    isFormValid={isFormValid}
                    registerReportFilterFunctions={registerReportFilterFunctions}
                    isSchedulingMode={isSchedulingMode}
                />
            );
        case REPORT_IDS.LocationSummaryPerProject:
            return (
                <LocationSummaryPerProject
                    report={report}
                    filters={filters}
                    urlParams={urlParams}
                    savedFilterValues={savedFilterValues}
                    isFormValid={isFormValid}
                    registerReportFilterFunctions={registerReportFilterFunctions}
                    isSchedulingMode={isSchedulingMode}
                />
            );
        case REPORT_IDS.ProjectList:
            return (
                <ProjectListFilters
                    report={report}
                    filters={filters}
                    urlParams={urlParams}
                    savedFilterValues={savedFilterValues}
                    isFormValid={isFormValid}
                    registerReportFilterFunctions={registerReportFilterFunctions}
                    isSchedulingMode={isSchedulingMode}
                />
            );
        case REPORT_IDS.ProjectsPerLocation:
            return (
                <ProjectsPerLocationFilters
                    report={report}
                    filters={filters}
                    urlParams={urlParams}
                    savedFilterValues={savedFilterValues}
                    isFormValid={isFormValid}
                    registerReportFilterFunctions={registerReportFilterFunctions}
                    isSchedulingMode={isSchedulingMode}
                />
            );
        case REPORT_IDS.ProjectTasksList:
            return (
                <ProjectTasksListFilters
                    report={report}
                    filters={filters}
                    urlParams={urlParams}
                    savedFilterValues={savedFilterValues}
                    isFormValid={isFormValid}
                    registerReportFilterFunctions={registerReportFilterFunctions}
                    onProjectChange={onProjectChange}
                    isSchedulingMode={isSchedulingMode}
                />
            );
        case REPORT_IDS.BaselineTaskList:
            return (
                <BaselineTaskListFilters
                    report={report}
                    filters={filters}
                    urlParams={urlParams}
                    savedFilterValues={savedFilterValues}
                    isFormValid={isFormValid}
                    registerReportFilterFunctions={registerReportFilterFunctions}
                    isSchedulingMode={isSchedulingMode}
                />
            );
        case REPORT_IDS.ProjectLocationsList:
            return (
                <ProjectLocListFilters
                    report={report}
                    filters={filters}
                    urlParams={urlParams}
                    savedFilterValues={savedFilterValues}
                    isFormValid={isFormValid}
                    registerReportFilterFunctions={registerReportFilterFunctions}
                    onProjectChange={onProjectChange}
                    isSchedulingMode={isSchedulingMode}
                    selectedProject={selectedProject}
                />
            );
        case REPORT_IDS.ProjectDeployment:
            return (
                <ProjectDeploymentListFilters
                    report={report}
                    filters={filters}
                    urlParams={urlParams}
                    savedFilterValues={savedFilterValues}
                    isFormValid={isFormValid}
                    registerReportFilterFunctions={registerReportFilterFunctions}
                    onProjectChange={onProjectChange}
                    isSchedulingMode={isSchedulingMode}
                />
            );
        case REPORT_IDS.UserList:
            return (
                <UserListFilters
                    report={report}
                    filters={filters}
                    urlParams={urlParams}
                    savedFilterValues={savedFilterValues}
                    isFormValid={isFormValid}
                    registerReportFilterFunctions={registerReportFilterFunctions}
                    isSchedulingMode={isSchedulingMode}
                />
            );
        case REPORT_IDS.MilestonesCrosstab:
            return (
                <MilestoneCrosstabFilters
                    report={report}
                    filters={filters}
                    savedFilterValues={savedFilterValues}
                    isFormValid={isFormValid}
                    registerReportFilterFunctions={registerReportFilterFunctions}
                    isSchedulingMode={isSchedulingMode}
                />
            );
        case REPORT_IDS.SupportTickets:
            return (
                <SupportTicketsFilters
                    report={report}
                    filters={filters}
                    savedFilterValues={savedFilterValues}
                    isFormValid={isFormValid}
                    registerReportFilterFunctions={registerReportFilterFunctions}
                    isSchedulingMode={isSchedulingMode}
                />
            );
        case REPORT_IDS.GMSummary:
            return (
                <GMSummaryFilters
                    report={report}
                    filters={filters}
                    urlParams={urlParams}
                    savedFilterValues={savedFilterValues}
                    isFormValid={isFormValid}
                    registerReportFilterFunctions={registerReportFilterFunctions}
                    isSchedulingMode={isSchedulingMode}
                />
            );
        case REPORT_IDS.PastDuePreRequisiteTask:
            return (
                <PastDuePreRequisiteTaskFilters
                    report={report}
                    filters={filters}
                    urlParams={urlParams}
                    savedFilterValues={savedFilterValues}
                    isFormValid={isFormValid}
                    registerReportFilterFunctions={registerReportFilterFunctions}
                    isSchedulingMode={isSchedulingMode}
                />
            );
        default: {
            return (<div>Unknown Report Id.  No filters available</div>);
        }
    }
}

ReportFiltersManager.propTypes = {
    report: PropTypes.object.isRequired,
    filters: PropTypes.object.isRequired,
    urlParams: PropTypes.object.isRequired,
    savedFilterValues: PropTypes.object.isRequired,
    isFormValid: PropTypes.bool.isRequired,
    isSchedulingMode: PropTypes.bool.isRequired,

    registerReportFilterFunctions: PropTypes.func.isRequired,
    onLocationChange: PropTypes.func,
    onProjectChange: PropTypes.func,
    onCoachChange: PropTypes.func,
    selectedProject: PropTypes.string
};

export default ReportFiltersManager;
